import Vue from "vue";
import VueRouter from "vue-router";

import LoginRoute from "../components/login/routes/index.js";
import DashboardRoute from "../components/dashboard/routes/index.js";
import OverviewRoute from "../components/overview/routes/index.js";
import TeamDetailsRoute from "../components/team-details/routes/index.js";
import UserRoute from "../components/users/routes/index.js";
import UserDirectoryRoute from "../components/user-directory/routes/index.js";
import UserActivityRoute from "../components/user_activities/routes/index.js";
import MeetingRoute from "../components/meetings/routes/index.js";
import ProjectRoute from "../components/projects/routes/index.js";
import MessageRoute from "../components/messages/routes/index.js";
import DocumentRoute from "@/components/documentsop/routes";
import GoalsRoute from "@/components/goals/routes";
import TimeTrackRoute from "@/components/timetrack/routes";
import ProfileRoute from "@/components/profile/routes";
import FeedbackRoute from "@/components/feedback/routes";
import ResourceRoute from "@/components/resources/routes";
import InboxRoute from "@/components/inbox/routes";
import PersonalResourcesRoute from "@/components/personalresources/routes";
import TaskApprovalRoute from "@/components/taskapproval/routes";
import LeaveManagementRoute from "@/components/leave-management/routes";
import LeaveActionRoute from "@/components/leave-action/routes";
import MyCalendarRoute from "@/components/my-calendar/routes";
import OvertimeManagementRoute from "@/components/overtime-management/routes";
import PayrollRoute from "@/components/payroll/routes";
import ResourcePlannerRoute from "@/components/resource-planner/routes";
import AiChatRoute from "@/components/aichat/routes";
import RecruitmentRoute from "@/components/recruitment/routes";
import EmailWarmupRoute from "@/components/email-warmup/routes";
import EmployeeGrowthRoute from "@/components/employee-growth/routes";
import AgentTimeTrackingRoute from "@/components/agent-time-tracking/routes";
import SettingsRoute from "@/components/settings/routes";
import ReportsRoute from "@/components/reports/routes";
import TeamsRoute from "@/components/teams/routes";
import SodEodRoute from "@/components/sod-eod/routes";
import FloorPlanRoute from "@/components/floor-plan/routes";
import AccountRequestRoute from "@/components/account-request/routes";
import CompaniesRoute from "@/components/companies/routes";
import SalesAssessmentRoute from "@/components/sales-assessment/routes";
import { hasAssessmentAccess } from "@/components/sales-assessment/admin/assessmentUi";


import store from '../plugins/vuex';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    ...LoginRoute,
    ...DashboardRoute,
    ...OverviewRoute,
    ...TeamDetailsRoute,
    ...UserRoute,
    ...UserDirectoryRoute,
    ...UserActivityRoute,
    ...MeetingRoute,
    ...ProjectRoute,
    ...MessageRoute,
    ...DocumentRoute,
    ...GoalsRoute,
    ...TimeTrackRoute,
    ...ProfileRoute,
    ...FeedbackRoute,
    ...ResourceRoute,
    ...InboxRoute,
    ...PersonalResourcesRoute,
    ...TaskApprovalRoute,
    ...LeaveManagementRoute,
    ...LeaveActionRoute,
    ...MyCalendarRoute,
    ...OvertimeManagementRoute,
    ...PayrollRoute,
    ...ResourcePlannerRoute,
    ...AiChatRoute,
    ...RecruitmentRoute,
    ...EmailWarmupRoute,
    ...EmployeeGrowthRoute,
    ...AgentTimeTrackingRoute,
    ...SettingsRoute,
    ...ReportsRoute,
    ...TeamsRoute,
    ...SodEodRoute,
    ...FloorPlanRoute,
    ...AccountRequestRoute,
    ...CompaniesRoute,
    ...SalesAssessmentRoute,
  ],
});

// Suppress NavigationDuplicated errors
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

// Route guard: check role-based and recruitment access
router.beforeEach((to, from, next) => {
  const user = store.getters['auth/get_user'];

  // Guest-guarded routes (e.g. floor plan) send logged-out visitors to the
  // self-service account request page instead of the normal role check below.
  if (to.meta?.requiresAuthOrAccountRequest && (!user || !user.id)) {
    return next({ name: 'RequestAccount' });
  }

  // Check role-based access
  const requiredRoles = to.meta?.requiresRole;
  if (requiredRoles && requiredRoles.length > 0) {
    const allowedUserIds = to.meta?.allowedUserIds || [];
    // Prefer role_members (multi-role support); fall back to the legacy single role_id
    const hasRole = user && user.role_members && user.role_members.length > 0
      ? user.role_members.some(m => requiredRoles.includes(m.user_role_id))
      : user && requiredRoles.includes(user.role_id);
    const isAllowedUser = user && allowedUserIds.includes(user.id);
    // Some routes are also open to users who manage at least one other user,
    // regardless of role (e.g. Time Tracking for managers)
    const managesUsers = to.meta?.requiresManagesUsers && user && ((user.managed_users && user.managed_users.length > 0) || !!user.time_tracking_manager);
    if (!hasRole && !isAllowedUser && !managesUsers) {
      return next({ path: '/dashboard' });
    }
  }


  // Routes limited to named people (e.g. Agent Settings), by login email.
  const allowedEmails = to.meta?.allowedEmails;
  if (allowedEmails && !allowedEmails.includes((user?.email || '').trim().toLowerCase())) {
    return next({ path: '/dashboard' });
  }

  // Check recruitment-specific access flag
  if (to.meta?.requiresRecruitmentAccess) {
    if (!user || user.is_recruitment_access !== 1) {
      return next({ path: '/dashboard' });
    }
  }

  // Sales assessments: recruitment access or Super Admin
  if (to.meta?.requiresAssessmentAccess && !hasAssessmentAccess(user)) {
    return next({ path: '/dashboard' });
  }

  next();
});

export default router;
